import { Card } from "@chakra-ui/react";
import React from 'react';
import IconComponent from "../ui/iconComponent";

const CardBox = (props) => {
  const {
    rootSize = "sm",
    headingSize = "xl",
    heading = "",
    bodyColor = "fg.muted",
    body = "",
    fontSize = "4xl",
    // rootWidth = "335px",
    rootMinHeight="150px",
    footer = "",
    shadow="md",
    border="none",
    source = ""
  } = props;

  return (
    <Card.Root
      size={rootSize}
      // width={rootWidth || "auto"}
      minW="200px"
      minH={rootMinHeight}
      flexDirection="row"
       overflow="hidden"
      border={border}
      flex={1}
      boxShadow={shadow}
      m={1}
      mb={3}
      p={1}
    >
      <Card.Body gap={3}>
        {/* "heading" text */}
        <Card.Description fontSize={headingSize} textWrap="nowrap" >
          {heading}
        </Card.Description>

        {/* Main "body" number or text */}
        <Card.Title
          fontSize={fontSize}
          fontWeight="bold"
          color={bodyColor}
          display="flex"
          flexDir="row"
          justifyContent="space-between"
        >
          {body}
          <IconComponent source={source} heading={heading} />
        </Card.Title>

        {/* Footer text (e.g. "14% from last month") */}
        <Card.Description textWrap="nowrap" position={"absolute"} bottom={3} left={6} fontSize={"md"} color="fg.muted">
          {footer}
        </Card.Description>
      </Card.Body>

      {/* Icon on the right side */}
      {/* <Card.Footer>
        <IconComponent source={source} heading={heading} />
      </Card.Footer> */}
    </Card.Root>
  );
};

export default CardBox;
